/* global app */
/* global event */
/* global calendar */

function findGetParameter(parameterName) {
    var result = null,
        tmp = [];
    location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
          tmp = item.split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
    return result;
}


app.controller('templatesCtrl', ['$rootScope', '$scope', '$http', '$compile', 'NetworkService', 'AtlasDialog', 'AtlasNotification', function($rootScope, $scope, $http, $compile, NetworkService, AtlasDialog, AtlasNotification) {

    $scope.templates = templates;
    
    $scope.openTemplate = function(id){
        window.location = "/template/"+id
    }
    
    $scope.templateSearch = findGetParameter("e");
}])
